import { axios } from '@Api/axiosClient';

const baseUrl: string = 'api/Pdf';

export const getPdfUrlApi = async (): Promise<string> => {
    const { data } = await axios.get<string>(`${baseUrl}/GetClientPdfUrl`);
    return data;
};
